import Toast from "shared/components/toast";
import AuthRoute from "shared/routes/authRoute";
import "./App.css";

function App() {
  return (
    <div className="App">
      <AuthRoute />
      <Toast />
    </div>
  );
}

export default App;
